import React from 'react';

import { Skeleton } from '@mui/material';

import CommitForm from '../../../../components/CommitForm';
import ContentCard from '../../../../components/ContentCard';
import { useUpdateExamMutation } from '../../../../services/exams';
import { Exam } from '../../../../services/exams/types';
import { Metadata } from '../../../../services/types';
import useError from '../../../../utils/react/hooks/useError';

interface ExamDetailsCardProps {
  exam?: Exam,
  examMetadata?: Metadata
}

const ExamDetailsCard = ({ exam, examMetadata }: ExamDetailsCardProps) => {
  const [updateExam, {
    isLoading: isUpdateExamLoading,
    isError: isUpdateExamError,
    error: updateExamError,
  }] = useUpdateExamMutation();

  useError(isUpdateExamError, updateExamError);

  if (!exam) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Exam Details">
      <CommitForm
        data={exam}
        metadata={examMetadata}
        fields={{
          id: {
            md: 12,
          },
          label: {
            md: 12,
          },
          shortLabel: {
            md: 12,
          },
          type: {
            md: 12,
          },
        }}
        onSubmit={async (values) => updateExam({
          subject: exam.subject,
          examId: exam.examId,
          attributes: values,
        })}
        isSubmitLoading={isUpdateExamLoading}
        autoSubmit
      />
    </ContentCard>
  );
};

export default ExamDetailsCard;
